import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fixed-deduction-form',
  templateUrl: './fixed-deduction-form.component.html',
  styleUrls: ['./fixed-deduction-form.component.css']
})
export class FixedDeductionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-form/fixed-deduction-form.component.ts